import { configureStore } from "@reduxjs/toolkit";
import appSlice from "./appSlice";
import chatSlice from "./chatSlice";
import loginSlice from "./loginSlice";
import insightsSlice from "./insightsSlice";
import scheduledAnalysisSlice from "./scheduledAnalysisSlice";

/**
 * Redux store configuration
 * Combines multiple slices into a single store
 * Slices: appSlice, loginSlice, chatSlice, insightsSlice
 * Exports the configured store for use in the application
 * @module store
 * @requires @reduxjs/toolkit
 * @requires ./appSlice
 * @requires ./loginSlice
 * @requires ./chatSlice
 * @requires ./insightsSlice
 * @returns {object} Configured Redux store
 */
const store = configureStore({
reducer:{
    app:appSlice,
    login:loginSlice,
    chat:chatSlice,
    insights:insightsSlice,
    scheduledAnalysis:scheduledAnalysisSlice,
}
})

export default store;